import { Injectable } from '@angular/core';
import {
  BokkzClient,
  CorporateTaxEntity,
  ErrorMessage,
  VpbAangifte,
  VpbBerekening,
  VpbRekenService,
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BokkzVpbDataService } from './bokkz-vpb-data-service';
import { ToastService } from '@snelstart/ui-toast';
import { catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BokkzVpbLogic {
  public errorResponse = {} as ErrorMessage[];
  public corporateTaxEntity = {} as CorporateTaxEntity;
  public corporateTaxEntityVergelijking = {} as CorporateTaxEntity;
  public vpbAangifte = {} as VpbAangifte;
  public vpbAangifteVergelijking = {} as VpbAangifte;
  public vpbBerekening = {} as VpbBerekening;
  public vpbBerekeningVergelijking = {} as VpbBerekening;
  public aantalValidaties = {} as number;
  public errorString = '';
  public isDefAangifte = false;

  constructor(
    private bokkzClient: BokkzClient,
    private vpbRekenservice: VpbRekenService,
    private toastService: ToastService,
    public dataService: BokkzVpbDataService,
  ) {
    if (this.dataService) {
      //Hier zorgen we ervoor we ervoor dat we nieuwe data binnenkrijgen en stoppen deze in de variabelen.
      this.dataService.corporateTaxEntity.subscribe(
        (value) => (this.corporateTaxEntity = value),
      );
      this.dataService.corporateTaxEntityVergelijking.subscribe(
        (value) => (this.corporateTaxEntityVergelijking = value),
      );
      this.dataService.vpbAangifteVergelijking.subscribe(
        (value) => (this.vpbAangifteVergelijking = value),
      );
      this.dataService.vpbBerekening.subscribe(
        (value) => (this.vpbBerekening = value),
      );
      this.dataService.vpbBerekeningVergelijking.subscribe(
        (value) => (this.vpbBerekeningVergelijking = value),
      );
      this.dataService.errorResponse.subscribe(
        (value) => (this.errorResponse = value),
      );
      this.dataService.aantalValidaties.subscribe(
        (value) => (this.aantalValidaties = value),
      );
      this.dataService.isDefAangifte.subscribe(
        (value) => (this.isDefAangifte = value),
      );
    }
  }

  public postCorporateTaxEntity(corporateTaxEntity: CorporateTaxEntity, sendToAuthorities: boolean, provisional: boolean, showMelding?: boolean) {
    const sstRelationIdfromEntity = corporateTaxEntity.sstRelationId;
    if (corporateTaxEntity.id !== null && corporateTaxEntity.sstRelationId !== undefined) {
      this.bokkzClient.postCorporateTax(sstRelationIdfromEntity!, sendToAuthorities, provisional, corporateTaxEntity).subscribe({
        next: (response) => {
          if (response && response.aangifte != null) {
            // this.dataService.updateCorporateTaxEntity(response);
          }
        },
        error: (err) => {
          console.log(err);
          this.toastService.showErrorMessage(`'De gegevens zijn niet opgeslagen.'`,);
        },
        complete: () => {
          if (this.isDefAangifte) {
            this.getValidation(corporateTaxEntity).subscribe();
          }
          this.getVpbBerekening();
        },
      });
    }
  }

  public getVpbBerekening(vpbAangifte?: VpbAangifte) {
    if (vpbAangifte) {
      this.vpbRekenservice.getCorporateTaxCalculation(vpbAangifte).subscribe({
        next: (response) => {
          this.dataService.updateVpbBerekening(response as VpbBerekening);
        },
        error: (err) => {
          console.log('VPB Berekening mislukt', err);
        },
        complete: () => console.log('complete'),
      });
    }
  }

  public getValidation(corporateTaxEntity: CorporateTaxEntity): Observable<void> {
    return this.vpbRekenservice.getCorporateTaxValidation(
      corporateTaxEntity.aangifte!,
      corporateTaxEntity.taxType!.includes('VA'),
    ).pipe(
      tap((response) => {
        if (response.belastbaarBedrag != null) {
          this.dataService.updateAantalValidaties(0);
          return;
        }

        if ('HV000028: Unexpected exception during isValid call.' === (response as unknown as string)) {
          this.errorString = response as unknown as string;
          const error: ErrorMessage[] = [
            {
              error: 'server.error',
              response: 'HV000028: Unexpected exception during isValid call.',
            },
          ];
          this.dataService.updateErrorResponse(error);
          this.dataService.updateAantalValidaties(1);
          return;
        }

        const errors = response as ErrorMessage[];
        this.dataService.updateErrorResponse(errors);
        this.dataService.updateAantalValidaties(errors.length);
      }),
      map(() => undefined),
      catchError((err) => {
        this.dataService.updateAantalValidaties(0);
        console.log(err);
        return of(undefined);
      }),
    );
  }

  public getVergelijkendeCijfers(taxId: string) {
    this.bokkzClient.getCorporateTax(String(this.corporateTaxEntity.clientId?.id!), taxId).subscribe({
        next: (result) => {
          if (result.aangifte !== null) {
            this.dataService.updateCorporateTaxEntityVergelijking(result);
            this.dataService.updateVpbAangifteVergelijking(
              result.aangifte as VpbAangifte,
            );
          }
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => console.log('complete'),
      });
    this.vpbRekenservice.getCorporateTaxValidation(this.vpbAangifteVergelijking, false).subscribe({
        next: (result) => {
          if (result.naamVennootschap !== null) {
            this.dataService.updateVpbBerekeningVergelijking(
              result as VpbBerekening,
            );
          }
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => console.log('complete'),
      });
  }
}
